<div class="media profile-media" role="button" (click)="toggleDropdown()">
	<img class="b-r-10" src="assets/images/dashboard/profile.png" alt="" />
	<div class="media-body">
		<span>{{ currentUser.firstName + ' ' + currentUser.lastName }}</span>
		<p class="mb-0 font-roboto" translate>
			{{ this.roleStatus | capitalize }} <i class="middle fa fa-angle-down"></i>
		</p>
	</div>
</div>

<ul class="profile-dropdown" [class.show]="isDropdownOpen">
	<li>
		<a routerLink="{{ route }}">
			<app-feather-icons [icon]="'user'"></app-feather-icons>
			<span>{{ 'Account' | translate }}</span>
		</a>
	</li>
	<li *ngIf="isOwner">
		<a routerLink="admin/account/billings">
			<app-feather-icons [icon]="'dollar-sign'"></app-feather-icons>
			<span>{{ 'Billings' | translate }}</span>
		</a>
	</li>
	<li *ngIf="isOwner">
		<a routerLink="admin/account/subscription">
			<app-feather-icons [icon]="'list'"></app-feather-icons>
			<span>{{ 'Subscription' | translate }}</span>
		</a>
	</li>
	<li (click)="logoutFunc()" class="d-flex">
		<app-feather-icons [icon]="'log-in'"></app-feather-icons>
		<span>{{ 'Log out' | translate }}</span>
	</li>
</ul>
